import getLineLocalId from '../getLineLocalId';
import getStraightLine from './getStraightLine';
import fetchRoutedLine from './fetchRoutedLine';
import convertLngLat from '../../mapbox/convertLngLat';

interface GetLineOptions {
    fromPoint: TrackPoint;
    draggingPointLocalId: string | undefined;
    project: MapProject;
    toPoint: TrackPoint;
    track: Track;
}

export default function getNormalRequest({
    fromPoint,
    draggingPointLocalId,
    project,
    toPoint,
    track,
}: GetLineOptions): TrackLineRequest {

    if (!track.isGeometryLoaded) throw new Error();

    const {unmodifiedLines, properties: {trackLocalId, color, routing_mode: costing}} = track;

    const isDragging = (
        fromPoint.properties.pointLocalId === draggingPointLocalId ||
        toPoint.properties.pointLocalId === draggingPointLocalId
    );

    const fromLngLat = convertLngLat(fromPoint.geometry.coordinates);
    const toLngLat = convertLngLat(toPoint.geometry.coordinates);
    const lineLocalId = getLineLocalId(trackLocalId, fromPoint, toPoint);

    const properties = {
        fromPointLocalId: fromPoint.properties.pointLocalId,
        lineLocalId,
        toPointLocalId: toPoint.properties.pointLocalId,
        trackLocalId,
        color,
    };

    const isGeometryModified = (
        fromPoint.properties.isGeometryModified ||
        toPoint.properties.isGeometryModified
    );

    if (isDragging) {
        return {
            type: 'sync',
            properties: {...properties, type: 'preview'},
            geometry: getStraightLine(fromLngLat, toLngLat)
        };

    } else if (unmodifiedLines && unmodifiedLines[lineLocalId] && !isGeometryModified) {
        return {
            type: 'sync',
            geometry: unmodifiedLines[lineLocalId].geometry,
            properties: {...properties, type: 'normal'},
        };

    } else {
        return {
            type: 'async',
            properties: {...properties, type: 'normal'},
            loadingGeometry: getStraightLine(fromLngLat, toLngLat),
            geometry: fetchRoutedLine({costing, fromLngLat, project, toLngLat})
        };
    }
}
